import store from '@/store'

function checkPermission(permissionMark) {
  // 从 store 中获取权限列表
  const permissions = store.state.user.permissions || []
  
  // 递归查找按钮权限
  const hasPermission = (items) => {
    for (const item of items) {
      if (item.type === 2 && item.permission_mark === permissionMark) {
        return true
      }
      if (item.children && item.children.length) {
        if (hasPermission(item.children)) {
          return true
        }
      }
    }
    return false
  }

  return hasPermission(permissions)
}

export default {
  inserted(el, binding) {
    const permissionMark = binding.value
    
    if (permissionMark) {
      const hasPermission = checkPermission(permissionMark)
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error('需要指定权限标记！')
    }
  }
} 